(function () {

  if (window.__mineralShipEst) return;
  window.__mineralShipEst = true;

  /* =====================================================
     GRILLE DE TRANSPORT : snippets/mpn-shipping-grid.liquid (source unique du site)
     ===================================================== */
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('mineral-ship-grid').textContent) || {}; } catch (e) {}
  var GRID = CFG.grid || [];
  var RELAY_MAX_KG = CFG.relayMaxKg || 30;   /* point relais possible jusqu'à ce poids */
  var RELAY_PRICE = CFG.relayPrice || 9.90;  /* tarif point relais */

  /* COMMANDE LOURDE : au-delà de ce poids (kg), délai 2 à 3 semaines + mention discrète */
  var HEAVY_KG = CFG.heavyKg || 800;

  /* ÉTIQUETTES PRODUIT (Shopify > produit > Étiquettes) */
  var TAG_FLAT = 'forfait_60';     /* livraison minimum, même sous 30 kg (risque de casse en colis) */
  var TAG_SAMPLE = 'echantillon';  /* frais de port offerts (inclus dans le prix) */
  var FLAT_MIN = CFG.flatMin || 60;

  /* ORDINATEUR : espace (en px) entre ce bloc et le bloc « Un doute sur la quantité… » en dessous */
  var SPACE_BELOW_DESKTOP = 20;

  /* Étiquettes « transport de la palette offert » : gratuit si la quantité commandée DÉPASSE le seuil. */
  var FREE_OVER = CFG.freeOver || {};

  var lang = (document.documentElement.lang || 'fr').slice(0, 2);

  var I18N = {
    fr: {
      home: 'Livraison à domicile sur RDV', estimate: '', relayLine: 'Point relais dès {r} € · domicile ≈ {h} €',
      note: 'Montant confirmé à l’étape de commande',
      quote: 'sur devis', quoteNote: 'Au-delà de 24 t, contactez-nous pour un devis de livraison.',
      free: 'Frais de port offerts', freeNote: 'Inclus dans le prix', freePallet: 'Transport offert', freePalletNote: 'Livraison de la palette incluse pour votre commande',
      pickup: 'Retrait gratuit dans nos 7 magasins', pickupSub: '6 en France · 1 en Allemagne',
      delayNormal: 'En stock, livré sous 1 à 2 semaines',
      delayHeavy: 'En stock, livré sous 2 à 3 semaines',
      heavy: 'Commande lourde · logistique adaptée · env. {w}',
      heavyAria: 'Voir comment se passe la livraison',
      safePal: 'Expédition sécurisée sur palette', safePalSub: 'Filmée, cerclée et contrôlée avant départ',
      safeBox: 'Expédition sécurisée en colis', safeBoxSub: 'Calé, protégé et contrôlé avant départ',
      kg: 'kg', t: 't', dec: ','
    },
    en: {
      home: 'Home delivery by appointment', estimate: '', relayLine: 'Pick-up point from €{r} · home ≈ €{h}',
      note: 'Amount confirmed at checkout',
      quote: 'on quote', quoteNote: 'Above 24 t, please contact us for a delivery quote.',
      free: 'Free shipping', freeNote: 'Included in the price', freePallet: 'Free delivery', freePalletNote: 'Pallet delivery included for your order',
      pickup: 'Free pick-up in our 7 stores', pickupSub: '6 in France · 1 in Germany',
      delayNormal: 'In stock, delivered within 1 to 2 weeks',
      delayHeavy: 'In stock, delivered within 2 to 3 weeks',
      heavy: 'Heavy order · suitable logistics · approx. {w}',
      heavyAria: 'See how delivery works',
      safePal: 'Secure pallet shipping', safePalSub: 'Wrapped, strapped and checked',
      safeBox: 'Secure parcel shipping', safeBoxSub: 'Padded, protected and checked',
      kg: 'kg', t: 't', dec: '.'
    },
    de: {
      home: 'Lieferung nach Hause nach Termin', estimate: '', relayLine: 'Abholstelle ab {r} € · nach Hause ≈ {h} €',
      note: 'Betrag wird beim Bezahlen bestätigt',
      quote: 'auf Anfrage', quoteNote: 'Ab 24 t erstellen wir Ihnen ein individuelles Lieferangebot.',
      free: 'Versandkostenfrei', freeNote: 'Im Preis inbegriffen', freePallet: 'Versandkostenfrei', freePalletNote: 'Palettenlieferung für Ihre Bestellung inklusive',
      pickup: 'Kostenlose Abholung in 7 Filialen', pickupSub: '1× Deutschland · 6× Frankreich',
      delayNormal: 'Auf Lager, Lieferung in 1 bis 2 Wochen',
      delayHeavy: 'Auf Lager, Lieferung in 2 bis 3 Wochen',
      heavy: 'Schwere Bestellung · passende Logistik · ca. {w}',
      heavyAria: 'So läuft die Lieferung ab',
      safePal: 'Sicherer Versand auf Palette', safePalSub: 'Foliert, umreift und geprüft',
      safeBox: 'Sicherer Versand als Paket', safeBoxSub: 'Gepolstert, geschützt, geprüft',
      kg: 'kg', t: 't', dec: ','
    }
  };
  var T = I18N[lang] || I18N.fr;

  var TRUCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
  var SHIELD = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 4.5 6v5.5c0 4.6 3.1 8.3 7.5 9.5 4.4-1.2 7.5-4.9 7.5-9.5V6z"/><path d="m8.8 12.2 2.3 2.3 4.2-4.6"/></svg>';
  var STORE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"/><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><path d="M2 7h20"/></svg>';

  var BOX = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>';
  var SHOP = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v11h16V9"/><path d="M3 9h18"/><path d="M10 20v-6h4v6"/></svg>';
  var TRUCK22 = TRUCK.replace(/width="16" height="16"/, 'width="22" height="22"').replace('stroke-width="1.7"', 'stroke-width="1.5"');
  var CHEV = '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg>';

  var style = document.createElement('style');
  style.textContent =
    '.mineral-ship-est{margin:10px 0 0;font-size:13.5px;line-height:1.4;color:#4a4c45}' +
    '.mineral-ship-est[hidden]{display:none!important}' +
    '.mineral-ship-est .mse-line{display:flex;align-items:flex-start;gap:8px}' +
    '.mineral-ship-est .mse-ico{flex:none;display:flex;margin-top:2px;color:#8a8d82}' +
    '.mineral-ship-est .mse-sub{display:block;font-size:12px;color:#8a8d82}' +
    '.mineral-ship-est .mse-heavy .mse-w{white-space:nowrap}' +
    '.mineral-ship-est .mse-heavy{display:block;font-size:12px;color:#4a4c45;margin-top:1px}' +
    '.mineral-ship-est button.mse-heavy{appearance:none;-webkit-appearance:none;background:none;border:0;padding:0;min-height:0;font-family:inherit;line-height:1.4;text-align:left;cursor:pointer;text-decoration:underline;text-decoration-color:rgba(74,76,69,.4);text-underline-offset:2px}' +
    '.mineral-ship-est button.mse-heavy:hover{text-decoration-color:currentColor}' +
    '.mineral-ship-est .mse-safe{display:flex;align-items:flex-start;gap:7px;margin:8px 0 2px;padding:7px 10px 7px 8px;background:#f4f3ef;border-left:2px solid #96c11f;color:#1b1b1b;text-align:left;width:100%;box-sizing:border-box}' +
    '.mineral-ship-est button.mse-safe{appearance:none;-webkit-appearance:none;border-top:0;border-right:0;border-bottom:0;min-height:0;font:inherit;line-height:1.35;cursor:pointer}' +
    '.mineral-ship-est .mse-safe svg{flex:none;margin-top:1px;color:#1b1b1b}' +
    '.mineral-ship-est .mse-safe b{display:block;font-size:13px;font-weight:600;line-height:1.3}' +
    '.mineral-ship-est .mse-safe small{display:block;font-size:12px;color:#575656;line-height:1.35}' +
    '.mineral-ship-est button.mse-safe:hover b{text-decoration:underline;text-underline-offset:2px}' +
    '.mineral-ship-est .mse-safe > span:nth-child(2){flex:1 1 auto;min-width:0;text-wrap:balance}' +
    '.mineral-ship-est .mse-safe b,.mineral-ship-est .mse-safe small{text-wrap:balance}' +
    '.mineral-ship-est .mse-safe-ph{flex:none;display:block;width:56px;height:42px;object-fit:cover;align-self:center;margin:0 3px 0 0}' +
    '.mineral-ship-est .mse-safe:has(.mse-safe-ph){align-items:center;padding:6px 8px 6px 6px}' +
    '.mineral-ship-est .mse-safe-go{flex:none;align-self:center;margin-left:2px;font-size:20px;line-height:1;color:#575656}' +
    '.mineral-ship-est .mse-pickup{margin-top:6px;color:#5a8a00}' +
    '.mineral-ship-est .mse-pickup .mse-ico{color:#5a8a00}' +
    '.mineral-ship-est .mse-pickup-sub{display:block;font-size:12px;font-style:italic;color:#6b6e64}' +
    /* nouvelle presentation (oct. 2026) */
    /* stock + livraison : une seule colonne alignee (point vert dans l'axe du camion, textes alignes) (Ed, oct. 2026) */
    '.product-buy-buttons__wrapper .product__shipping-info{text-align:left!important;margin-top:14px!important;padding-left:7px!important}' +
    '.product-buy-buttons__wrapper .product__shipping-status{column-gap:21px!important}' +
    '.mineral-ship-est:not(.mse-out){margin:10px 0 0;font-size:14px}' +
    '.mineral-ship-est .mse-line{gap:14px;align-items:center}' +
    '.mineral-ship-est .mse-line > span:last-child{color:#1b1b1b;font-weight:500;font-size:14.5px;line-height:1.3}' +
    '.mineral-ship-est .mse-line .mse-sub{font-weight:400;font-size:12.5px;color:#777;margin-top:2px}' +
    '.mineral-ship-est .mse-line .mse-heavy{font-weight:400}' +
    '.mineral-ship-est .mse-ico{margin-top:0;color:#1b1b1b}' +
    /* meme marge interieure que le bloc gris (14 px) : camion, palette, magasin et telephone sur le meme axe */
    '.mse-out{margin:6px 0 0;padding:0 14px;color:#1b1b1b}' +
    '.product__info-container > .mse-out{margin-top:6px!important}' +
    '.mse-out .mse-row:first-child{padding-top:8px}' +
    '.mse-out[hidden]{display:none!important}' +
    '.mse-out .mse-row{display:flex;align-items:center;gap:14px;width:100%;margin:0;padding:14px 0;border:0;border-bottom:1px solid #e7e5df;border-radius:0;background:none;color:inherit;font:inherit;text-align:left;-webkit-appearance:none;appearance:none;min-height:0;box-shadow:none}' +
    '.mse-out button.mse-row{cursor:pointer}' +
    '.mse-out .mse-ri{flex:none;display:flex;color:#1b1b1b}' +
    '.mse-out .mse-rt{flex:1 1 auto;min-width:0}' +
    '.mse-out .mse-rt b{display:block;font-size:14.5px;font-weight:500;line-height:1.3}' +
    '.mse-out .mse-rt small{display:block;margin-top:2px;font-size:12.5px;line-height:1.35;color:#777}' +
    '.mse-out .mse-rgo{flex:none;display:flex;color:#333}' +
    '@media (hover:hover){.mse-out button.mse-row:hover b{text-decoration:underline;text-underline-offset:2px}}' +
    '.product__info-container > .product__reassurances{display:none!important}' +
    '.pose-accessories__title{text-transform:none!important;letter-spacing:0!important}' +
    '.pose-accessories__count .mpn-pa-for{display:inline!important;margin:0!important}' +
    'html:not([lang^="de"]) .pose-accessories__count .mpn-pa-for{text-transform:lowercase}' +
    '.pose-accessories__count .mpn-pa-for:not(:empty)::before{content:" "}' +
    'html[lang^="de"] .pose-accessories__count .mpn-pa-for:not(:empty)::before{content:" · "}';
  document.head.appendChild(style);

  function euros(n) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function humanWeight(kg) {
    var hundreds = Math.round(kg / 100) * 100;
    if (hundreds < 1000) return hundreds + ' ' + T.kg;
    var t = Math.round(kg / 100) / 10;
    var s = (t % 1 === 0) ? String(t) : t.toFixed(1);
    return s.replace('.', T.dec) + ' ' + T.t;
  }

  function shippingFor(kg) {
    for (var i = 0; i < GRID.length; i++) { if (kg <= GRID[i][0]) return GRID[i][1]; }
    return null;
  }

  function isFreeFor(d, qty) {
    return Object.keys(FREE_OVER).some(function (tag) {
      return hasTag(d, tag) && qty > FREE_OVER[tag];
    });
  }

  function hasTag(d, tag) {
    return (d.tags || []).some(function (t) {
      return String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').trim() === tag;
    });
  }

  function parseMoney(txt) {
    var m = String(txt || '').replace(/[^\d,]/g, '').replace(',', '.');
    var v = parseFloat(m);
    return isNaN(v) ? null : v;
  }

  function variantsData() {
    var el = document.querySelector('script[data-mineral-ship-est]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Variante choisie : formulaire « Ajouter au panier » PRINCIPAL. On ignore la barre collante (-sticky), les
     formulaires de paiement en plusieurs fois (installment) et les encarts (accessoires, panier...) : leur id
     pouvait rester sur le 1er format et l'estimation prenait son poids (ex. 60 € pour un lot de 600 kg, oct. 2026). */
  function currentVariantId(d) {
    var ok = function (v) { return v && d.variants[String(v)] !== undefined; };
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i], fid = f.id || '';
      if (/-sticky$/.test(fid) || /installment/.test(fid)) continue;
      if (f.closest('cart-drawer, dialog, pose-accessories, .pose-accessories, .mpn-sticky-atc, sticky-add, quick-add-modal, .mpn-so')) continue;
      var inp = f.querySelector('[name="id"]');
      if (inp && ok(inp.value)) return String(inp.value);
    }
    var q = new URLSearchParams(location.search).get('variant');
    if (ok(q)) return String(q);
    return String(d.selected);
  }

  function mainQty() {
    if (typeof window.mpnMainQty === 'function') return window.mpnMainQty();
    var inp = document.querySelector('.quantity__input');
    var v = inp ? parseInt(inp.value, 10) : 1;
    return isNaN(v) || v < 1 ? 1 : v;
  }

  function accessoriesKg() {
    var pa = document.querySelector('pose-accessories');
    if (!pa || typeof pa.getSelectedItems !== 'function') return 0;
    var weights = {};
    pa.querySelectorAll('.pose-accessories__row').forEach(function (row) {
      if (row.dataset.variantId) weights[row.dataset.variantId] = parseFloat(row.dataset.weight) || 0;
      if (row.dataset.containers) {
        try {
          JSON.parse(row.dataset.containers).forEach(function (c) {
            if (c && c.id) weights[String(c.id)] = parseFloat(c.weight) || 0;
          });
        } catch (e) {}
      }
    });
    var kg = 0;
    pa.getSelectedItems().forEach(function (it) {
      kg += (weights[String(it.id)] || 0) * (parseInt(it.quantity, 10) || 0);
    });
    return kg;
  }

  function totalAmount() {
    var nodes = document.querySelectorAll('.product-buy-buttons__price .price__container span.price-item');
    for (var i = 0; i < nodes.length; i++) {
      var v = parseMoney(nodes[i].textContent);
      if (v !== null && nodes[i].getClientRects().length) return v;
    }
    return nodes.length ? parseMoney(nodes[0].textContent) : null;
  }

  window.mineralShipQuote = function (extraKg) {
    var d = variantsData();
    if (!d) return null;
    var vid = currentVariantId(d);
    var qty = mainQty();
    if (hasTag(d, TAG_SAMPLE) || isFreeFor(d, qty)) return { price: 0 };
    var unitKg = d.variants[vid] || 0;
    if (unitKg <= 0) return null;
    var s = shippingFor(unitKg * qty + (extraKg || 0));
    if (s === null) return { price: null };
    if (hasTag(d, TAG_FLAT) && s < FLAT_MIN) s = FLAT_MIN;
    return { price: s };
  };

  function updateDelay(d, vid, heavy) {
    var hasDispo = d.dispo && d.dispo[vid] === true;
    var available = !d.avail || d.avail[vid] !== false;
    if (hasDispo || !available) return;
    var wanted = heavy ? T.delayHeavy : T.delayNormal;
    document.querySelectorAll('.product__shipping-status').forEach(function (el) {
      if (el.closest('cart-drawer, dialog')) return;
      if (el.classList.contains('product__shipping-status--pending')) return;
      if (el.textContent.trim() !== wanted) el.textContent = wanted;
    });
  }

  function deliveryTrigger() {
    return document.querySelector('.mineral-delivery-trigger');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mse-heavy[data-open-delivery], .mse-safe[data-open-delivery], .mse-row--safe[data-open-delivery]');
    if (!b) return;
    var trig = deliveryTrigger();
    if (!trig) return;
    e.preventDefault();
    trig.click();
  });

  function getBox() {
    var box = document.querySelector('.mineral-ship-est:not(.mse-out)');
    if (box && box.isConnected) return box;
    box = document.createElement('div');
    box.className = 'mineral-ship-est';
    box.hidden = true;
    var status = document.querySelector('.product__shipping-info') ||
                 (document.querySelector('.product__shipping-status') || {}).parentElement;
    if (status && status.parentElement) {
      status.insertAdjacentElement('afterend', box);
      return box;
    }
    var anchor = document.querySelector('.product__price-details') ||
                 document.querySelector('.product__total-price-row');
    if (!anchor) return null;
    anchor.insertAdjacentElement('afterend', box);
    return box;
  }

  /* lignes palette + magasins : sur fond blanc, juste sous le bloc gris d'achat (avant « Un doute… ») */
  function topOf(el) {
    while (el && el.parentElement && !el.parentElement.classList.contains('product__info-container')) el = el.parentElement;
    return el && el.parentElement ? el : null;
  }
  function getOut() {
    var out = document.querySelector('.mse-out');
    if (!out || !out.isConnected) {
      out = document.createElement('div');
      out.className = 'mse-out';
      out.hidden = true;
    }
    /* place (ou replace si la page a fini de se construire apres coup) : juste avant « Un doute… », sinon apres le bloc d'achat */
    var ph = topOf(document.querySelector('.product__info-container .mineral-phone-block'));
    var w = topOf(document.querySelector('.product__info-container .product-buy-buttons__wrapper'));
    if (ph) { if (out.nextElementSibling !== ph) ph.insertAdjacentElement('beforebegin', out); }
    else if (w) { if (!out.isConnected) w.insertAdjacentElement('afterend', out); }
    else return null;
    return out;
  }
  var lastOut = '';
  function renderOut(rows) {
    var out = getOut();
    if (!out) return;
    if (rows === lastOut && !out.hidden === !!rows) return;
    lastOut = rows;
    out.innerHTML = rows;
    out.hidden = !rows;
  }
  function pickupRow(sample) {
    if (sample) return '';
    var src = document.querySelector('[data-mpn-rea-stores][data-href]');
    var inner = '<span class="mse-ri">' + SHOP + '</span><span class="mse-rt"><b>' + T.pickup + '</b>' +
                (T.pickupSub ? '<small>' + T.pickupSub + '</small>' : '') + '</span>';
    if (src) return '<button type="button" class="mse-row mse-row--pickup" data-mpn-rea-stores data-href="' + src.getAttribute('data-href') + '">' + inner + '<span class="mse-rgo">' + CHEV + '</span></button>';
    return '<span class="mse-row mse-row--pickup">' + inner + '</span>';
  }

  var last = '';

  function render() {
    var d = variantsData();
    if (!d) return;
    var vid = currentVariantId(d);
    var sample = hasTag(d, TAG_SAMPLE);
    var flat = hasTag(d, TAG_FLAT);
    var unitKg = d.variants[vid] || 0;
    var qty = mainQty();
    var kg = unitKg * qty + accessoriesKg();
    var heavy = !sample && kg > HEAVY_KG;

    updateDelay(d, vid, heavy);

    var box = getBox();
    if (!box) return;

    var total = totalAmount();
    var freePallet = isFreeFor(d, qty);

    if ((!sample && !freePallet && unitKg <= 0) || total === null) {
      if (!box.hidden) { box.hidden = true; last = ''; }
      renderOut(pickupRow(sample));
      return;
    }

    var ship = shippingFor(kg);
    var hasTrigger = !!deliveryTrigger();

    var oEl = getOut();
    var key = [kg, lang, sample, flat, freePallet, hasTrigger, !!oEl, !!(oEl && !oEl.hidden)].join('|');
    if (key === last && !box.hidden) return;
    last = key;

    var html = '';
    var line, sub = '';
    var rel = RELAY_PRICE;

    if (sample) {
      line = '<span style="color:#5a8a00;font-weight:600">' + T.free + '</span>';
      sub = T.freeNote;
    } else if (freePallet) {
      line = '<span style="color:#5a8a00;font-weight:600">' + T.freePallet + '</span>';
      sub = T.freePalletNote;
    } else if (ship === null) {
      line = T.home + ' : ' + T.quote;
      sub = T.quoteNote;
    } else {
      if (flat && ship < FLAT_MIN) ship = FLAT_MIN;
      if (!flat && kg <= RELAY_MAX_KG) {
        line = T.relayLine.replace('{r}', euros(rel)).replace('{h}', euros(ship));
      } else {
        line = T.home + ' ≈ ' + euros(ship) + ' €';
      }
      sub = T.note;
    }

    var heavyText = T.heavy.replace('{w}', humanWeight(kg));
    /* poids + unite jamais coupes en fin de ligne (« env. 26,9 t ») */
    var heavyHtml = T.heavy.replace(/(\S+ )?\{w\}/, function (m, pre) { return '<span class="mse-w">' + (pre || '') + humanWeight(kg) + '</span>'; });
    var heavyLine = '';
    if (heavy) {
      heavyLine = hasTrigger
        ? '<button type="button" class="mse-heavy" data-open-delivery aria-label="' + heavyText + ' – ' + T.heavyAria + '">' + heavyHtml + '</button>'
        : '<span class="mse-heavy">' + heavyHtml + '</span>';
    }

    /* Expédition sécurisée : palette au-delà du point relais (> 30 kg), forfait 60 ou palette offerte ;
       sinon colis (cas des tarifs 9,90 / 14,90 € et des échantillons). Photo de palette seulement pour une palette, bouclier pour un colis.
       Seule la ligne PALETTE ouvre le panneau livraison (demande d'Ed) : en colis, simple ligne de réassurance, sans flèche. */
    var safeLine = '';
    if (true) {
      var pal = !sample && (flat || freePallet || kg > RELAY_MAX_KG);
      var link = hasTrigger && pal;
      var sT = pal ? T.safePal : T.safeBox, sS = pal ? T.safePalSub : T.safeBoxSub;
      var inner = '<span class="mse-ri">' + BOX + '</span><span class="mse-rt"><b>' + sT + '</b><small>' + sS + '</small></span>' + (link ? '<span class="mse-rgo">' + CHEV + '</span>' : '');
      safeLine = link
        ? '<button type="button" class="mse-row mse-row--safe" data-open-delivery aria-label="' + sT + ' – ' + T.heavyAria + '">' + inner + '</button>'
        : '<span class="mse-row mse-row--safe">' + inner + '</span>';
      /* colis : ligne retiree (demande d'Ed, oct. 2026 : « l'info n'apporte rien ») ; seule la palette reste */
      if (!pal) safeLine = '';
    }

    html += '<div class="mse-line"><span class="mse-ico">' + TRUCK22 + '</span>' +
            '<span>' + line + heavyLine + (sub ? '<span class="mse-sub">' + sub + '</span>' : '') + '</span></div>';
    /* repere invisible : le panneau livraison sait qu'une ligne palette cliquable existe (prechargement des photos,
       carte « Livraison a domicile sur RDV » masquee : snippets/mpn-prep-livraison.liquid) */
    /* toujours present (meme en colis, ligne retiree) : sinon la carte « Livraison a domicile sur RDV » reapparait */
    html += '<span class="mse-safe"' + (safeLine.indexOf('data-open-delivery') > -1 ? ' data-open-delivery' : '') + ' style="display:none!important" aria-hidden="true"></span>';

    box.innerHTML = html;
    box.hidden = false;
    renderOut(safeLine + pickupRow(sample));
  }

  render();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  setInterval(render, 400);
  document.addEventListener('pose-accessories:change', render);
  document.addEventListener('input', render, true);
  document.addEventListener('change', render, true);
  document.addEventListener('click', function () { setTimeout(render, 60); }, true);

})();
